var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { CallSupport } from '@/components/call-support.component';
export function IdleModalContent() {
    return (_jsxs("div", __assign({ className: "grid gap-4 py-6" }, { children: [_jsx(Typography, __assign({ variant: "h5", className: "text-xl" }, { children: "Make your best guess..." })), _jsx(Typography, __assign({ variant: "body1", className: "text-lg" }, { children: "You have not yet submitted your response. If you are unsure, make your best guess." }))] })));
}
export function HelpModalContent(_a) {
    var sendButtonClick = _a.sendButtonClick;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-10 items-center" }, { children: [_jsx(Typography, __assign({ variant: "h2" }, { children: "Help" })), _jsxs(Typography, __assign({ className: "text-lg" }, { children: ["We will play ", _jsx("span", __assign({ className: 'font-bold' }, { children: "3 numbers" })), " with background noise. ", _jsx("br", {}), " Enter the numbers you hear in the order you hear them and press ", _jsx("span", __assign({ className: 'font-bold' }, { children: "OK." }))] })), _jsx(Typography, __assign({ className: "text-lg" }, { children: "It's ok to guess if you can't hear clearly." })), _jsx(CallSupport, { onClick: function () { return sendButtonClick('test_support'); }, classes: {
                    textClass: 'flex flex-col text-left items-center',
                    containerClass: 'm-0 -ml-12',
                } })] })));
}
